/**
 * Where Mauvely Scope lives.
 *
 * Derived from this page's own hostname, the same substitution the
 * notification bell already does for Review (`components/NotificationBell.tsx`),
 * plus the localhost arm `accountOrigin()` uses — Scope runs on :8790 in
 * development, and a hardcoded production origin would make the handoff
 * impossible to exercise locally.
 *
 * This is a plain navigation, not a fetch. `connect-src` in
 * worker/lib/headers.ts governs fetches and does not need Scope's origin
 * added to it — resist the urge.
 */

export function scopeOrigin(): string {
  const { hostname, protocol } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return `${protocol}//${hostname}:8790`;

  const host = hostname.replace(/^cloud\./, 'scope.');
  return host.startsWith('scope.') ? `https://${host}` : 'https://scope.mauvely.com';
}

/** Where "New Scope project" goes. */
export const newScopeProjectHref = (): string => `${scopeOrigin()}/new`;
